/**
 * Syncs the user saved at the store with the sessionStorage.
 * By doing this, we can safely reload without losing the session, and no
 * problems arise from having multiple tabs open, as each has its own storage.
 */
const sessionStorageHelper = ({ dispatch, getState }) => {

  let state = getState()

  return (next) => (action) => {
    if (action.type === '@@_AFTER_RENDER') {
      // After first render, read saved state
      // (We have to wait until render so SSR and first render match)
      const payload = JSON.parse(window.sessionStorage.getItem('user'))
      payload && dispatch({ type: 'user/login', payload })
    }
    const ret = next(action)
    const newState = getState()
    if (state.user !== newState.user) {
      window.sessionStorage.setItem('user', JSON.stringify(newState.user))
      state = newState
    }
    return ret
  }
}

export default sessionStorageHelper
